import React from 'react';
import { AdjustTypeCssClasses, AdjustTypeTitles } from '../../StocksUIHelpers';

export function TypeColumnFormatter(cellContent, row) {
  const getLabelCssClasses = () => {
    return `label label-lg label-light-${
      AdjustTypeCssClasses[getTitleInd(cellContent)]
    } label-inline`;
  };
  function getTitleInd(typeCode) {
    switch (typeCode) {
      case 'NONE':
        return 1;
      case 'EXTRACTED':
        return 2;
      case 'DIVIDED':
        return 3;
      case 'CHANGED':
        return 4;
      default:
        return 1;
    }
  }
  return (
    <span className={getLabelCssClasses()}>
      {AdjustTypeTitles[getTitleInd(cellContent)]}
    </span>
  );
}
